module.exports = __webpack_public_path__ + "static/media/closeMsgActive.97fb4f3c.svg";